/**
 * 客户回款，银行登记单 新增页面 表单配置处理
 * @author zjs
 * @time 2017-10-25
 */
export default {
    data () {
        return {
            // 表单组件配置
            formConfig: [{
                name: "登记日期",
                type: "LyDatePicker",
                field: "work_time",
                json: {
                    type: 'date'
                },
                default: ""
            },{
                name: "回款日期",
                type: "LyDatePicker",
                field: "huikuan_time",
                json: {
                    type: 'date',
                    span: 12
                },
                default: ""
            },{
                name: "收款账户",
                type: "LyAutoSearch",
                field: "shoukuanzh",
                width: '220px',
                json: {
                    width: '271px',
                    api: 'api/shoukuanzh',
                    prop: 'label',
                    fields: [{
                        label: '收款账户',
                        prop: 'label',
                        width: 270
                    }]
                },
                default: {}
            },{
                name: "收款金额",
                type: "LyInputNumber",
                field: "shoukuan_amount",
                width: '220px',
                json: {},
                default: ""
            },{
                name: "登记人",
                type: "ElInput",
                field: "dengjiren",
                default: ""
            },{
                name: "摘要",
                placeholder: "请输入摘要",
                type: "ElInput",
                field: "zhaiyao",
                width: '1005px',
                json: {
                    span: 24
                },
                default: ""
            }]
        }
    }
}